import { useEffect, useState } from "react";
import { NamesOfFieldEnum, OrgTypeEnum } from "~/typings/types";
import {
  DefaultPage,
  useAttachmentsDetails,
} from "~/pages/questionnaires/shared";
import {
  CompanyDetails,
  AccountDetails,
  PayformTechDetails,
  AdditionalDetails,
  AttachmentsDetails,
} from "./steps";
import { HELPER_FILE } from "../../../api/apiUrls";
import { V2Wizard } from "../../../shared/wizard";

const COUNT_UPLOAD_LOGO_FILE = 1;
const COUNT_UPLOAD_PASSPORT_FILE = 2;

export const SelfEmployedLiteStep = ({
  clientId,
  paymentMethod,
  educationalPlatform,
  queryPromocode,
  setOrgType,
  productType,
  ...sharedStepProps
}: any) => {
  const [textLinkAttachment, setTextLinkAttachment] = useState('');
  const [isFirstRenderPayformTechDetailsStep, setIsFirstRenderPayformTechDetailsStep] = useState(false);

  useEffect(() => {
    setOrgType(OrgTypeEnum.SelfEmployed);
  }, []);

  const attachmentsDetails = useAttachmentsDetails({
    clientId,
    orgType: OrgTypeEnum.SelfEmployed,
    initialLogoFileId: sharedStepProps.initialValues.logo_main_file_id,
    initialPassportFileId: sharedStepProps.initialValues.passport_file_id,
    initialPassportMainFileId: sharedStepProps.initialValues.passport_main_file_id,
    initialPassportRegistrationFileId: sharedStepProps.initialValues.passport_registration_file_id,
    initialDocumentAgreement1FileId: sharedStepProps.initialValues.document_agreement1_file_id,
    initialDocumentAgreement2FileId: sharedStepProps.initialValues.document_agreement2_file_id,
    initialDocumentPricesTariffsFileId: sharedStepProps.initialValues.prices_tariffs_file_id,
    urlHelperFile: HELPER_FILE,
    textLinkAttachment
  });

  return (
    <V2Wizard
      {...sharedStepProps}
      logoFileId={attachmentsDetails.logoFileId}
      passportMainFileId={attachmentsDetails.passportMainFileId}
      passportRegistrationFileId={attachmentsDetails.passportRegistrationFileId}
      documentAgreement1FileId={attachmentsDetails.documentAgreement1FileId}
      documentAgreement2FileId={attachmentsDetails.documentAgreement2FileId}
      documentPricesTariffsFileId={attachmentsDetails.documentPricesTariffsFileId}
      handleRequestAttachmentsDetails={attachmentsDetails.handleRequestAttachmentsDetails}
      isLoadingAttachmentsDetails={attachmentsDetails.isLoadingAttachmentsDetails}
      isErrorAttachmentsDetails={attachmentsDetails.isErrorAttachmentsDetails}
      pricesTariffsLinkError={attachmentsDetails.pricesTariffsLinkError}
      errorUploadOffer={sharedStepProps.errorUploadOffer}
      setErrorUploadOffer={sharedStepProps.setErrorUploadOffer}
      isGeneratedOffer={sharedStepProps.isGeneratedOffer}
      setIsGeneratedOffer={sharedStepProps.setIsGeneratedOffer}
      isRequiredOffer={true}
    >
      <DefaultPage />
      <AccountDetails clientId={clientId} isShowAdditionalFieldsInitially={true} orgType={OrgTypeEnum.SelfEmployed} />
      <CompanyDetails clientId={clientId} />
      <PayformTechDetails
        {...attachmentsDetails}
        clientId={clientId}
        COUNT_UPLOAD_LOGO_FILE={COUNT_UPLOAD_LOGO_FILE}
        COUNT_UPLOAD_PASSPORT_FILE={COUNT_UPLOAD_PASSPORT_FILE}
        orgType={OrgTypeEnum.SelfEmployed}
        paymentMethod={paymentMethod}
        educationalPlatform={educationalPlatform}
        productType={productType}
        typeRequestCheckPayformName={sharedStepProps.typeRequestCheckPayformName}
        setTypeRequestCheckPayformName={sharedStepProps.setTypeRequestCheckPayformName}
        callbackCheckPayformName={sharedStepProps.callbackCheckPayformName}
        errorMsgCheckPayformName={sharedStepProps.errorMsgCheckPayformName}
        isFirstRenderPayformTechDetailsStep={isFirstRenderPayformTechDetailsStep}
        setIsFirstRenderPayformTechDetailsStep={setIsFirstRenderPayformTechDetailsStep}
        setIsLogoProcessing={sharedStepProps.setIsLogoProcessing}
      />
      <AdditionalDetails queryPromocode={queryPromocode} />
      <AttachmentsDetails
        {...attachmentsDetails}
        clientId={clientId}
        COUNT_UPLOAD_LOGO_FILE={COUNT_UPLOAD_LOGO_FILE}
        COUNT_UPLOAD_PASSPORT_FILE={COUNT_UPLOAD_PASSPORT_FILE}
        orgType={OrgTypeEnum.SelfEmployed}
        textLinkAttachment={textLinkAttachment}
        setTextLinkAttachment={setTextLinkAttachment}
        isUploadOffer={sharedStepProps.isUploadOffer}
        setIsUploadOffer={sharedStepProps.setIsUploadOffer}
        errorUploadOffer={sharedStepProps.errorUploadOffer}
        setErrorUploadOffer={sharedStepProps.setErrorUploadOffer}
        offer={sharedStepProps.offer}
        textLinkOffer={sharedStepProps.textLinkOffer}
        setTextLinkOffer={sharedStepProps.setTextLinkOffer}
        isGeneratedOffer={sharedStepProps.isGeneratedOffer}
        setIsGeneratedOffer={sharedStepProps.setIsGeneratedOffer}
      />
    </V2Wizard>
  );
};
